import React from "react";

function KpkCom() {
  return (
    <div className="py-5">
      <div className="row row-cols-1 row-cols-md-2">
        <div className="col">
          <h2 className="text-h-m-orange">
            Former FATA and Khyber Pakhtunkhwa
          </h2>
          <br />
          <br />
          <h2 className="text-h-black">Criminalising Dissent as Militancy</h2>
          <br />
          <br />
          <br />
          <br />
          <p>
            Colonial narratives of Pashtuns as noble but savage, tribal warriors
            have been internalised by Pakistan in the post-9/11 era, informing a
            perception of Pashtuns as a threat to national security. In
            attempting to understand the prison system, it is this historical
            landscape that needs to be understood, including the region's
            anti-colonial movement and the imprisonment of political agitators.
            In retaliation against the Khudai Khidmatgar, the British clamped
            down even harder to portray Pashtuns as a treacherous criminally
            tribal group incapable of being civilly governed. In doing so, they
            introduced the language and discourse of terrorism to typify
            Pashtuns.
          </p>
        </div>
        <div className="col">
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/KP-and-FATA-2.png")}
            alt="KP-and-FATA-2"
          />
        </div>
      </div>
    </div>
  );
}

export default KpkCom;
